<template>
    <div class="records">
        <el-timeline :style="tableStyle" v-if="recrodList.length >0">
            <el-timeline-item v-for="(item, index) in recrodList" :key="index"
                :timestamp="item.created | filterTime('YYYY-MM-DD HH:mm:SS')" placement="top">
                <div class="records-item-content">
                    <div style="color:#888;">操作人：{{ item.operator }}</div>
                    <div style="margin-top: 8px;">{{ item.remark }}</div>
                </div>
            </el-timeline-item>
        </el-timeline>
        <div v-else class="flex-center">
            <el-empty description="暂无记录"></el-empty>
        </div>
    </div>
</template>

<script>
export default {
    name: 'orderRecord',
    props: {
        tableStyle: {
            type: String,
            default: () => {
                return 'height: calc(100vh - 144px)'
            }
        },
        orderId: {
            type: [String, Number],
            default: () => {
                return ''
            }
        }
    },
    created() {
        this.getRecord()
    },
    data() {
        return {
            recrodList: []
        }
    },
    methods: {
        async getRecord() {
            let url = '/api/v1/manage/order/hitchRide/status/record';
            const { code, data } = await this.$axios.get(url, {
                orderId: this.orderId,
                page: 1,
                size: 500
            });
            if (code === 1) {
                this.recrodList = data.reverse()
            }
        }
    }
}
</script>

<style lang="less" scoped>
.records {
    padding-left: 170px;

    /deep/ .el-timeline{
        height: auto !important;
    }

    /deep/ .el-timeline-item__timestamp.is-top {
        position: relative;
        left: -170px;
    }
    .records-item-content{
        position: relative;
        top: -24px;
    }
}
</style>